function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1226 2H3.87256C3.37632 2.00129 2.90078 2.19899 2.54988 2.54988C2.19899 2.90078 2.00129 3.37632 2 3.87256V20.1274C2.00172 20.6244 2.20023 21.1004 2.55209 21.4514C2.90395 21.8023 3.38049 21.9996 3.87744 22H20.1258C20.622 21.9987 21.0976 21.801 21.4485 21.4501C21.7994 21.0992 21.9971 20.6237 21.9984 20.1274V3.87582C21.9984 3.37832 21.8007 2.9012 21.449 2.54941C21.0972 2.19763 20.6201 2 20.1226 2ZM19.8667 19.8748H4.11864V4.12842H19.8667V19.8748Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.96024 18.4814C6.26988 18.4814 6.50294 17.5329 6.48012 16.3742C6.4573 15.2155 6.19003 14.2832 5.88038 14.2881C5.57236 14.2881 5.33931 15.2366 5.3605 16.3937C5.38168 17.5508 5.65222 18.4863 5.96187 18.4814H5.96024Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0068 19.0306C10.3165 19.0306 10.5495 18.0821 10.5267 16.9234C10.5039 15.7647 10.2366 14.8324 9.92697 14.8373C9.61732 14.8373 9.38427 15.7858 9.40709 16.9446C9.4299 18.1033 9.69718 19.0355 10.0068 19.0306Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0747 17.9925C14.3827 17.9925 14.6157 17.044 14.5945 15.8853C14.5734 14.7265 14.3028 13.7943 13.9932 13.7992C13.6835 13.7992 13.4505 14.7477 13.4733 15.9048C13.4961 17.0619 13.7634 17.9974 14.073 17.9925H14.0747Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6845 18.7031C17.9941 18.7031 18.2272 17.7546 18.2044 16.5975C18.1815 15.4404 17.9126 14.5049 17.603 14.5114C17.2933 14.5114 17.0603 15.4599 17.0831 16.617C17.1059 17.7741 17.3748 18.7096 17.6845 18.7031Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.57692 14.1203C7.88657 14.1203 8.11962 13.1718 8.0968 12.0147C8.07399 10.8576 7.80508 9.92212 7.49706 9.92864C7.18742 9.92864 6.956 10.8771 6.97718 12.0342C6.99837 13.1913 7.2689 14.1268 7.57855 14.1203H7.57692Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8419 14.1203C12.1499 14.1203 12.383 13.1718 12.3618 12.0147C12.3406 10.8576 12.0701 9.92212 11.7604 9.92864C11.4508 9.92864 11.2177 10.8771 11.2405 12.0342C11.2633 13.1913 11.5306 14.1268 11.8403 14.1203H11.8419Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2862 14.0958C16.5942 14.0958 16.8272 13.1473 16.806 11.9902C16.7849 10.8331 16.5143 9.89765 16.2047 9.90417C15.895 9.90417 15.662 10.8527 15.6848 12.0098C15.7076 13.1669 15.9765 14.1023 16.2845 14.0958H16.2862Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6753 9.25554C13.985 9.25554 14.218 8.30704 14.1952 7.14994C14.1724 5.99283 13.897 5.05737 13.5939 5.06389C13.2842 5.06389 13.0512 6.01239 13.074 7.16949C13.0968 8.3266 13.3657 9.26206 13.6753 9.25554Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M9.7135 10.354C10.0232 10.354 10.2562 9.40546 10.2334 8.24672C10.2106 7.08799 9.94329 6.15579 9.63365 6.16068C9.32563 6.16068 9.09258 7.10918 9.11376 8.26791C9.13495 9.42665 9.40549 10.3588 9.71513 10.354H9.7135Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M5.79727 9.60918C6.10691 9.60918 6.33996 8.66068 6.31715 7.50357C6.29433 6.34647 6.02706 5.411 5.71741 5.42241C5.40939 5.42241 5.17634 6.37091 5.19753 7.52802C5.21871 8.68512 5.48925 9.62059 5.7989 9.61407L5.79727 9.60918Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6845 9.37612C17.9941 9.37612 18.2272 8.42762 18.2044 7.26889C18.1815 6.11015 17.9126 5.17795 17.603 5.18284C17.2933 5.18284 17.0603 6.13134 17.0831 7.29008C17.1059 8.44881 17.3748 9.38101 17.6845 9.37612Z"
});

function SvgPlaceTerrainGras(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceTerrainGras);
export default __webpack_public_path__ + "static/media/place_terrain_gras.05f13ac5.svg";
export { ForwardRef as ReactComponent };